import { render, staticRenderFns } from "./ContentFeedCover.vue?vue&type=template&id=716d2606&scoped=true&"
import script from "./ContentFeedCover.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedCover.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedCover.vue?vue&type=style&index=0&id=716d2606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716d2606",
  null
  
)

export default component.exports